import { render, staticRenderFns } from "./PostPostPanel.vue?vue&type=template&id=5ada92c3&scoped=true&lang=pug&"
import script from "./PostPostPanel.vue?vue&type=script&lang=js&"
export * from "./PostPostPanel.vue?vue&type=script&lang=js&"
import style0 from "./PostPostPanel.vue?vue&type=style&index=0&id=5ada92c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada92c3",
  null
  
)

export default component.exports